// extracted by mini-css-extract-plugin
export default {"title":"Bid_title__5QPT5","info":"Bid_info__7VhiO","stage":"Bid_stage__XabvS","row":"Bid_row__T+qs8","col":"Bid_col__JfYjT","btns":"Bid_btns__T9JDk","button":"Bid_button__9lHjh"};